<div class="dialog">
  <div class="dialog-header">
    <span class="dialog-title">{{ title }}</span>
    <button type="button" class="close-btn" [disabled]="isLoading" (click)="close()" aria-label="Close">×</button>
  </div>

  <p class="dialog-note">{{ data.name }}</p>

  <div class="dialog-form">
    <div class="field-row">
      <div class="field">
        <span class="field-label">New status</span>
        <select class="text-box-active" [(ngModel)]="status" (change)="refreshReasons()">
          <option value="ACTIVE">Active</option>
          <option value="INACTIVE">Inactive</option>
        </select>
      </div>
      <div class="field">
        <span class="field-label">Reason</span>
        <select class="text-box-active" [(ngModel)]="statusReason">
          <option value="">Pick a reason</option>
          @for(r of reasons; track r){ <option [value]="r">{{ r }}</option> }
        </select>
      </div>
    </div>
    @if(data.kind === 'set'){
    <div class="flag-row">
      <label class="flag">
        <input type="checkbox" [(ngModel)]="applyToRooms" />
        Also apply this status to every room in this guest house
      </label>
    </div>
    }
  </div>

  <div class="dialog-actions">
    <button type="button" class="ac-secondary-btn" (click)="close()">Cancel</button>
    <button type="button" class="ac-primary-btn" (click)="submit()">Apply</button>
  </div>
</div>

<app-loader [isLoading]="isLoading"></app-loader>
